import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

function Doughnut() {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }
    
        const ctx = chartRef.current.getContext('2d');
    
        chartInstance.current = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Facturados', 'No Facturados'],
            datasets: [{
              label: '',
              data: [12, 19],
              backgroundColor: ['#31d4be', '#d4c131'],
              hoverOffset: 0
            }]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });

        return () => {
            if (chartInstance.current) {
              chartInstance.current.destroy();
            }
        };
    }, []);

    return (
      <canvas style={{width: '100%'}} ref={chartRef}></canvas>
    )
};

export default Doughnut;